//250 ms * (2^0)= 250 ms
//250 ms * (2^1)= 500 ms
//250 ms * (2^2)= 1000 ms
//250 ms * (2^3)= 2000 ms
//250 ms * (2^4)= 4000 ms

const exponentialDelay = (attemptIndex) => Math.min(250 * 2 ** attemptIndex, 5000);

export { exponentialDelay };
